import type { ChatMessage } from "../chat/types";

export type Moment = {
  time: string;
  tag: string;
  heading: string;
  body: string;
  msgs: ChatMessage[];
  // Optional override — image-bearing moments need extra room.
  chatHeight?: number;
  // Optional override — heavier scenes (image + research) deserve a longer
  // pause before the typewriter loops so visitors can actually read them.
  loopRestartMs?: number;
};

export const MOMENTS: Moment[] = [
  {
    time: "07:42",
    tag: "morning",
    heading: "You open Telegram. 91 unread.",
    body: "Your bot already triaged them. Three need you, eighty-eight don't.",
    msgs: [
      {
        from: "bot",
        text: "☀️ 91 unreads since yesterday.\n\n3 need you:\n• Marco @ Helius — wants the deck\n• REM Capital — confirming Thurs call\n• OKX intro — they replied\n\nThe rest: vendors, group chatter, newsletters. Want a one-line summary?",
      },
    ],
  },
  {
    time: "09:14",
    tag: "never forget a face",
    heading: "You met someone last night.",
    body: "You told Sidestack to enrich every new person you meet. Now it does — every time, the next morning, before you've even had coffee.",
    msgs: [
      {
        from: "bot",
        text: "Last night you met Maya Chen at the Superteam Solana meetup.",
      },
      {
        from: "bot",
        text: "Here's what I dug up on him:\n• BD at Kairo (just raised a Series A)\n• Runs their Solana ecosystem partnerships\n• Strong fit for what you're building\n\nI added him to HubSpot. Want me to draft a follow-up?",
      },
      { from: "bot", kind: "action", actions: ["Draft it", "Skip"] },
    ],
  },
  {
    time: "11:18",
    tag: "in a call",
    heading: "You're on a call. A lead pings you.",
    body: "Sidestack drafts a reply in your voice and holds it for you to send after.",
    msgs: [
      {
        from: "bot",
        text: 'Sarah just messaged: "still good for next week?"\n\nDraft holding for you:\n\n"Yep — Tues 2pm works. Sending the calendar invite now."\n\nSend now, edit, or ignore?',
      },
      { from: "bot", kind: "action", actions: ["Send", "Edit"] },
    ],
  },
  {
    time: "14:05",
    tag: "who?",
    heading: "A name comes up. You blank.",
    body: "Ask Sidestack like you'd ask a coworker. It pulls from your past chats.",
    msgs: [
      { from: "user", text: "who is dani park again?" },
      {
        from: "bot",
        text: 'Dani Park — met at ETH Denver afterparty (Apr 18). Founding PM at Vector. You promised her a Helius intro. Last msg 4 days ago: "super keen — anytime next week works."',
      },
    ],
  },
  {
    time: "15:50",
    tag: "pre-call",
    heading: "10 min before your 4pm. Brief incoming.",
    body: "Last 5 messages, the ask, the open thread. So you walk in already caught up.",
    msgs: [
      {
        from: "bot",
        text: '⏱️ 4pm w/ Pascal · Focal VC — 10 min out\n\nLast time: he asked for the Q3 update.\nOpen thread: still owe him your runway numbers.\n\nLead with: "Got the Q3 update for you — landed at $1.4M MRR." That\'s the unlock.',
      },
    ],
  },
  {
    time: "23:11",
    tag: "going dark",
    heading: "A deal's gone quiet. You haven't noticed.",
    body: "Sidestack notices. You wake up to a draft already written.",
    msgs: [
      {
        from: "bot",
        text: 'Heads up — Marco @ Helius hasn\'t replied in 6 days. Last warm signal: "let me circle with the team."\n\nI drafted a nudge in your voice. Want it queued for 9am tomorrow?',
      },
      { from: "bot", kind: "action", actions: ["Queue 9am", "Hold"] },
    ],
  },
];
